/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */

import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import './MorningstarRating.scss';

const MorningstarRating = props => {
	const {
		stars,
		starSize,
		translate,
		style
	} = props;

	const starRatings = [];
	const translateKey = stars === 5 ? 'starsOfStarsMaxRating' : 'starsOfStarsRating';

	for (let index = 1; index <= 5; index += 1) {
		starRatings.push(
			<Icon
				key={`star-rating-${index}`}
				className="star"
				iconName={index <= stars ? 'morningStar' : 'morningStarOpen'}
				style={{ width: starSize }} />
		);
	}

	return (
		<div className="morningstar-rating" style={style}>
			{starRatings}
			<span className="sr-only">{translate && translate(translateKey, { stars, max: 5 })}</span>
		</div>
	);
};

/**
 * Helpful info for adding prop types
 * https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
 */
MorningstarRating.propTypes = {
	stars: PropTypes.number,
	starSize: PropTypes.number,
	translate: PropTypes.func,
	style: PropTypes.any
};

MorningstarRating.defaultProps = {
	stars: 0,
	starSize: 20,
	translate: () => {}
};

export default withTranslate(MorningstarRating);
